import { render } from "./App.vue?vue&type=template&id=01aeb0f8"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=01aeb0f8&lang=css"

import exportComponent from "/home/usuario/Proyectos/2025/ArkhamHorror/App_Arkham_Horror_3/multigames/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__